// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  type CommentCreate,
  CommentCreateFromJSON,
  CommentCreateToJSON,
} from "../models/CommentCreate";
import {
  type CommentEventCreate,
  CommentEventCreateFromJSON,
  CommentEventCreateToJSON,
} from "../models/CommentEventCreate";
import { type CommentRead, CommentReadFromJSON, CommentReadToJSON } from "../models/CommentRead";
import {
  type DefaultErrorResponse,
  DefaultErrorResponseFromJSON,
  DefaultErrorResponseToJSON,
} from "../models/DefaultErrorResponse";
import {
  type MessageCreate,
  MessageCreateFromJSON,
  MessageCreateToJSON,
} from "../models/MessageCreate";
import {
  type MessageUpdate,
  MessageUpdateFromJSON,
  MessageUpdateToJSON,
} from "../models/MessageUpdate";
import {
  type PageCommentRead,
  PageCommentReadFromJSON,
  PageCommentReadToJSON,
} from "../models/PageCommentRead";
import {
  type ValidationErrorResponse,
  ValidationErrorResponseFromJSON,
  ValidationErrorResponseToJSON,
} from "../models/ValidationErrorResponse";

export interface CommentAddMessageRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  publicationId: string;
  /**
   *
   */
  commentId: string;
  /**
   *
   */
  messageCreate: MessageCreate;
}

export interface CommentAddReactionRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  publicationId: string;
  /**
   *
   */
  commentId: string;
  /**
   *
   */
  messageIndex: number;
  /**
   *
   */
  emoji: string;
}

export interface CommentCreateRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  publicationId: string;
  /**
   *
   */
  commentCreate: CommentCreate;
}

export interface CommentDeleteRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  publicationId: string;
  /**
   *
   */
  commentId: string;
}

export interface CommentDeleteMessageRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  publicationId: string;
  /**
   *
   */
  commentId: string;
  /**
   *
   */
  messageIndex: number;
}

export interface CommentDeleteReactionRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  publicationId: string;
  /**
   *
   */
  commentId: string;
  /**
   *
   */
  messageIndex: number;
  /**
   *
   */
  emoji: string;
}

export interface CommentListRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  publicationId: string;
  /**
   *
   */
  limit?: number;
  /**
   *
   */
  offset?: number;
  /**
   *
   */
  orderBy?: CommentListOrderByEnum;
  /**
   *
   */
  orderByCaseSensitive?: boolean;
  /**
   *
   */
  resolved?: boolean | null;
  /**
   *
   */
  mapId?: number | null;
}

export interface CommentResolveRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  publicationId: string;
  /**
   *
   */
  commentId: string;
  /**
   *
   */
  commentEventCreate: CommentEventCreate;
}

export interface CommentRetrieveRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  publicationId: string;
  /**
   *
   */
  commentId: string;
}

export interface CommentUnresolveRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  publicationId: string;
  /**
   *
   */
  commentId: string;
  /**
   *
   */
  commentEventCreate: CommentEventCreate;
}

export interface CommentUpdateMessageRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  publicationId: string;
  /**
   *
   */
  commentId: string;
  /**
   *
   */
  messageIndex: number;
  /**
   *
   */
  messageUpdate: MessageUpdate;
}

/**
 *
 */
export class PublicationCommentsApi extends runtime.BaseAPI {
  /**
   * Creates request options for commentAddMessage without sending the request
   */
  async commentAddMessageRequestOpts(
    requestParameters: CommentAddMessageRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling commentAddMessage().'
      );
    }

    if (requestParameters["publicationId"] == null) {
      throw new runtime.RequiredError(
        "publicationId",
        'Required parameter "publicationId" was null or undefined when calling commentAddMessage().'
      );
    }

    if (requestParameters["commentId"] == null) {
      throw new runtime.RequiredError(
        "commentId",
        'Required parameter "commentId" was null or undefined when calling commentAddMessage().'
      );
    }

    if (requestParameters["messageCreate"] == null) {
      throw new runtime.RequiredError(
        "messageCreate",
        'Required parameter "messageCreate" was null or undefined when calling commentAddMessage().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "publication_comment",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/publications/{publication_id}/comments/{comment_id}/messages`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{publication_id}",
      encodeURIComponent(String(requestParameters["publicationId"]))
    );
    urlPath = urlPath.replace(
      "{comment_id}",
      encodeURIComponent(String(requestParameters["commentId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: MessageCreateToJSON(requestParameters["messageCreate"]),
    };
  }

  /**
   * Add a message to a comment on a publication
   * Add a message
   */
  async commentAddMessageRaw(
    requestParameters: CommentAddMessageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CommentRead>> {
    const requestOptions = await this.commentAddMessageRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => CommentReadFromJSON(jsonValue));
  }

  /**
   * Add a message to a comment on a publication
   * Add a message
   */
  async commentAddMessage(
    requestParameters: CommentAddMessageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CommentRead> {
    const response = await this.commentAddMessageRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for commentAddReaction without sending the request
   */
  async commentAddReactionRequestOpts(
    requestParameters: CommentAddReactionRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling commentAddReaction().'
      );
    }

    if (requestParameters["publicationId"] == null) {
      throw new runtime.RequiredError(
        "publicationId",
        'Required parameter "publicationId" was null or undefined when calling commentAddReaction().'
      );
    }

    if (requestParameters["commentId"] == null) {
      throw new runtime.RequiredError(
        "commentId",
        'Required parameter "commentId" was null or undefined when calling commentAddReaction().'
      );
    }

    if (requestParameters["messageIndex"] == null) {
      throw new runtime.RequiredError(
        "messageIndex",
        'Required parameter "messageIndex" was null or undefined when calling commentAddReaction().'
      );
    }

    if (requestParameters["emoji"] == null) {
      throw new runtime.RequiredError(
        "emoji",
        'Required parameter "emoji" was null or undefined when calling commentAddReaction().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "publication_comment",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/publications/{publication_id}/comments/{comment_id}/messages/{message_index}/reactions/{emoji}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{publication_id}",
      encodeURIComponent(String(requestParameters["publicationId"]))
    );
    urlPath = urlPath.replace(
      "{comment_id}",
      encodeURIComponent(String(requestParameters["commentId"]))
    );
    urlPath = urlPath.replace(
      "{message_index}",
      encodeURIComponent(String(requestParameters["messageIndex"]))
    );
    urlPath = urlPath.replace("{emoji}", encodeURIComponent(String(requestParameters["emoji"])));

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Add an emoji reaction to a message on a comment
   * Add a reaction
   */
  async commentAddReactionRaw(
    requestParameters: CommentAddReactionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CommentRead>> {
    const requestOptions = await this.commentAddReactionRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => CommentReadFromJSON(jsonValue));
  }

  /**
   * Add an emoji reaction to a message on a comment
   * Add a reaction
   */
  async commentAddReaction(
    requestParameters: CommentAddReactionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CommentRead> {
    const response = await this.commentAddReactionRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for commentCreate without sending the request
   */
  async commentCreateRequestOpts(
    requestParameters: CommentCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling commentCreate().'
      );
    }

    if (requestParameters["publicationId"] == null) {
      throw new runtime.RequiredError(
        "publicationId",
        'Required parameter "publicationId" was null or undefined when calling commentCreate().'
      );
    }

    if (requestParameters["commentCreate"] == null) {
      throw new runtime.RequiredError(
        "commentCreate",
        'Required parameter "commentCreate" was null or undefined when calling commentCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "publication_comment",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/publications/{publication_id}/comments`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{publication_id}",
      encodeURIComponent(String(requestParameters["publicationId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CommentCreateToJSON(requestParameters["commentCreate"]),
    };
  }

  /**
   * Create a comment on a publication
   * Create a comment
   */
  async commentCreateRaw(
    requestParameters: CommentCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CommentRead>> {
    const requestOptions = await this.commentCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => CommentReadFromJSON(jsonValue));
  }

  /**
   * Create a comment on a publication
   * Create a comment
   */
  async commentCreate(
    requestParameters: CommentCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CommentRead> {
    const response = await this.commentCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for commentDelete without sending the request
   */
  async commentDeleteRequestOpts(
    requestParameters: CommentDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling commentDelete().'
      );
    }

    if (requestParameters["publicationId"] == null) {
      throw new runtime.RequiredError(
        "publicationId",
        'Required parameter "publicationId" was null or undefined when calling commentDelete().'
      );
    }

    if (requestParameters["commentId"] == null) {
      throw new runtime.RequiredError(
        "commentId",
        'Required parameter "commentId" was null or undefined when calling commentDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "publication_manage",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/publications/{publication_id}/comments/{comment_id}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{publication_id}",
      encodeURIComponent(String(requestParameters["publicationId"]))
    );
    urlPath = urlPath.replace(
      "{comment_id}",
      encodeURIComponent(String(requestParameters["commentId"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Delete a comment on a publication
   * Delete a comment
   */
  async commentDeleteRaw(
    requestParameters: CommentDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.commentDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a comment on a publication
   * Delete a comment
   */
  async commentDelete(
    requestParameters: CommentDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.commentDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for commentDeleteMessage without sending the request
   */
  async commentDeleteMessageRequestOpts(
    requestParameters: CommentDeleteMessageRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling commentDeleteMessage().'
      );
    }

    if (requestParameters["publicationId"] == null) {
      throw new runtime.RequiredError(
        "publicationId",
        'Required parameter "publicationId" was null or undefined when calling commentDeleteMessage().'
      );
    }

    if (requestParameters["commentId"] == null) {
      throw new runtime.RequiredError(
        "commentId",
        'Required parameter "commentId" was null or undefined when calling commentDeleteMessage().'
      );
    }

    if (requestParameters["messageIndex"] == null) {
      throw new runtime.RequiredError(
        "messageIndex",
        'Required parameter "messageIndex" was null or undefined when calling commentDeleteMessage().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "publication_comment",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/publications/{publication_id}/comments/{comment_id}/messages/{message_index}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{publication_id}",
      encodeURIComponent(String(requestParameters["publicationId"]))
    );
    urlPath = urlPath.replace(
      "{comment_id}",
      encodeURIComponent(String(requestParameters["commentId"]))
    );
    urlPath = urlPath.replace(
      "{message_index}",
      encodeURIComponent(String(requestParameters["messageIndex"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Delete a message from a comment on a publication
   * Delete a message
   */
  async commentDeleteMessageRaw(
    requestParameters: CommentDeleteMessageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CommentRead>> {
    const requestOptions = await this.commentDeleteMessageRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => CommentReadFromJSON(jsonValue));
  }

  /**
   * Delete a message from a comment on a publication
   * Delete a message
   */
  async commentDeleteMessage(
    requestParameters: CommentDeleteMessageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CommentRead> {
    const response = await this.commentDeleteMessageRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for commentDeleteReaction without sending the request
   */
  async commentDeleteReactionRequestOpts(
    requestParameters: CommentDeleteReactionRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling commentDeleteReaction().'
      );
    }

    if (requestParameters["publicationId"] == null) {
      throw new runtime.RequiredError(
        "publicationId",
        'Required parameter "publicationId" was null or undefined when calling commentDeleteReaction().'
      );
    }

    if (requestParameters["commentId"] == null) {
      throw new runtime.RequiredError(
        "commentId",
        'Required parameter "commentId" was null or undefined when calling commentDeleteReaction().'
      );
    }

    if (requestParameters["messageIndex"] == null) {
      throw new runtime.RequiredError(
        "messageIndex",
        'Required parameter "messageIndex" was null or undefined when calling commentDeleteReaction().'
      );
    }

    if (requestParameters["emoji"] == null) {
      throw new runtime.RequiredError(
        "emoji",
        'Required parameter "emoji" was null or undefined when calling commentDeleteReaction().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "publication_comment",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/publications/{publication_id}/comments/{comment_id}/messages/{message_index}/reactions/{emoji}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{publication_id}",
      encodeURIComponent(String(requestParameters["publicationId"]))
    );
    urlPath = urlPath.replace(
      "{comment_id}",
      encodeURIComponent(String(requestParameters["commentId"]))
    );
    urlPath = urlPath.replace(
      "{message_index}",
      encodeURIComponent(String(requestParameters["messageIndex"]))
    );
    urlPath = urlPath.replace("{emoji}", encodeURIComponent(String(requestParameters["emoji"])));

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Remove your emoji reaction from a message on a comment
   * Remove a reaction
   */
  async commentDeleteReactionRaw(
    requestParameters: CommentDeleteReactionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CommentRead>> {
    const requestOptions = await this.commentDeleteReactionRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => CommentReadFromJSON(jsonValue));
  }

  /**
   * Remove your emoji reaction from a message on a comment
   * Remove a reaction
   */
  async commentDeleteReaction(
    requestParameters: CommentDeleteReactionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CommentRead> {
    const response = await this.commentDeleteReactionRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for commentList without sending the request
   */
  async commentListRequestOpts(
    requestParameters: CommentListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling commentList().'
      );
    }

    if (requestParameters["publicationId"] == null) {
      throw new runtime.RequiredError(
        "publicationId",
        'Required parameter "publicationId" was null or undefined when calling commentList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["orderBy"] != null) {
      queryParameters["order_by"] = requestParameters["orderBy"];
    }

    if (requestParameters["orderByCaseSensitive"] != null) {
      queryParameters["order_by_case_sensitive"] = requestParameters["orderByCaseSensitive"];
    }

    if (requestParameters["resolved"] != null) {
      queryParameters["resolved"] = requestParameters["resolved"];
    }

    if (requestParameters["mapId"] != null) {
      queryParameters["map_id"] = requestParameters["mapId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "publication_read",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/publications/{publication_id}/comments`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{publication_id}",
      encodeURIComponent(String(requestParameters["publicationId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Get the comments of a publication
   * Get comments
   */
  async commentListRaw(
    requestParameters: CommentListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PageCommentRead>> {
    const requestOptions = await this.commentListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PageCommentReadFromJSON(jsonValue));
  }

  /**
   * Get the comments of a publication
   * Get comments
   */
  async commentList(
    requestParameters: CommentListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PageCommentRead> {
    const response = await this.commentListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for commentResolve without sending the request
   */
  async commentResolveRequestOpts(
    requestParameters: CommentResolveRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling commentResolve().'
      );
    }

    if (requestParameters["publicationId"] == null) {
      throw new runtime.RequiredError(
        "publicationId",
        'Required parameter "publicationId" was null or undefined when calling commentResolve().'
      );
    }

    if (requestParameters["commentId"] == null) {
      throw new runtime.RequiredError(
        "commentId",
        'Required parameter "commentId" was null or undefined when calling commentResolve().'
      );
    }

    if (requestParameters["commentEventCreate"] == null) {
      throw new runtime.RequiredError(
        "commentEventCreate",
        'Required parameter "commentEventCreate" was null or undefined when calling commentResolve().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "publication_comment",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/publications/{publication_id}/comments/{comment_id}/resolve`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{publication_id}",
      encodeURIComponent(String(requestParameters["publicationId"]))
    );
    urlPath = urlPath.replace(
      "{comment_id}",
      encodeURIComponent(String(requestParameters["commentId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CommentEventCreateToJSON(requestParameters["commentEventCreate"]),
    };
  }

  /**
   * Resolve a comment on a publication
   * Resolve a comment
   */
  async commentResolveRaw(
    requestParameters: CommentResolveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CommentRead>> {
    const requestOptions = await this.commentResolveRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => CommentReadFromJSON(jsonValue));
  }

  /**
   * Resolve a comment on a publication
   * Resolve a comment
   */
  async commentResolve(
    requestParameters: CommentResolveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CommentRead> {
    const response = await this.commentResolveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for commentRetrieve without sending the request
   */
  async commentRetrieveRequestOpts(
    requestParameters: CommentRetrieveRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling commentRetrieve().'
      );
    }

    if (requestParameters["publicationId"] == null) {
      throw new runtime.RequiredError(
        "publicationId",
        'Required parameter "publicationId" was null or undefined when calling commentRetrieve().'
      );
    }

    if (requestParameters["commentId"] == null) {
      throw new runtime.RequiredError(
        "commentId",
        'Required parameter "commentId" was null or undefined when calling commentRetrieve().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "publication_read",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/publications/{publication_id}/comments/{comment_id}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{publication_id}",
      encodeURIComponent(String(requestParameters["publicationId"]))
    );
    urlPath = urlPath.replace(
      "{comment_id}",
      encodeURIComponent(String(requestParameters["commentId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Get a comment from a publication
   * Get a comment
   */
  async commentRetrieveRaw(
    requestParameters: CommentRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CommentRead>> {
    const requestOptions = await this.commentRetrieveRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => CommentReadFromJSON(jsonValue));
  }

  /**
   * Get a comment from a publication
   * Get a comment
   */
  async commentRetrieve(
    requestParameters: CommentRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CommentRead> {
    const response = await this.commentRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for commentUnresolve without sending the request
   */
  async commentUnresolveRequestOpts(
    requestParameters: CommentUnresolveRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling commentUnresolve().'
      );
    }

    if (requestParameters["publicationId"] == null) {
      throw new runtime.RequiredError(
        "publicationId",
        'Required parameter "publicationId" was null or undefined when calling commentUnresolve().'
      );
    }

    if (requestParameters["commentId"] == null) {
      throw new runtime.RequiredError(
        "commentId",
        'Required parameter "commentId" was null or undefined when calling commentUnresolve().'
      );
    }

    if (requestParameters["commentEventCreate"] == null) {
      throw new runtime.RequiredError(
        "commentEventCreate",
        'Required parameter "commentEventCreate" was null or undefined when calling commentUnresolve().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "publication_comment",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/publications/{publication_id}/comments/{comment_id}/unresolve`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{publication_id}",
      encodeURIComponent(String(requestParameters["publicationId"]))
    );
    urlPath = urlPath.replace(
      "{comment_id}",
      encodeURIComponent(String(requestParameters["commentId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CommentEventCreateToJSON(requestParameters["commentEventCreate"]),
    };
  }

  /**
   * Unresolve a comment on a publication
   * Unresolve a comment
   */
  async commentUnresolveRaw(
    requestParameters: CommentUnresolveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CommentRead>> {
    const requestOptions = await this.commentUnresolveRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => CommentReadFromJSON(jsonValue));
  }

  /**
   * Unresolve a comment on a publication
   * Unresolve a comment
   */
  async commentUnresolve(
    requestParameters: CommentUnresolveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CommentRead> {
    const response = await this.commentUnresolveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for commentUpdateMessage without sending the request
   */
  async commentUpdateMessageRequestOpts(
    requestParameters: CommentUpdateMessageRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling commentUpdateMessage().'
      );
    }

    if (requestParameters["publicationId"] == null) {
      throw new runtime.RequiredError(
        "publicationId",
        'Required parameter "publicationId" was null or undefined when calling commentUpdateMessage().'
      );
    }

    if (requestParameters["commentId"] == null) {
      throw new runtime.RequiredError(
        "commentId",
        'Required parameter "commentId" was null or undefined when calling commentUpdateMessage().'
      );
    }

    if (requestParameters["messageIndex"] == null) {
      throw new runtime.RequiredError(
        "messageIndex",
        'Required parameter "messageIndex" was null or undefined when calling commentUpdateMessage().'
      );
    }

    if (requestParameters["messageUpdate"] == null) {
      throw new runtime.RequiredError(
        "messageUpdate",
        'Required parameter "messageUpdate" was null or undefined when calling commentUpdateMessage().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "publication_comment",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/publications/{publication_id}/comments/{comment_id}/messages/{message_index}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{publication_id}",
      encodeURIComponent(String(requestParameters["publicationId"]))
    );
    urlPath = urlPath.replace(
      "{comment_id}",
      encodeURIComponent(String(requestParameters["commentId"]))
    );
    urlPath = urlPath.replace(
      "{message_index}",
      encodeURIComponent(String(requestParameters["messageIndex"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: MessageUpdateToJSON(requestParameters["messageUpdate"]),
    };
  }

  /**
   * Update a message from a comment on a publication
   * Update a message
   */
  async commentUpdateMessageRaw(
    requestParameters: CommentUpdateMessageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CommentRead>> {
    const requestOptions = await this.commentUpdateMessageRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => CommentReadFromJSON(jsonValue));
  }

  /**
   * Update a message from a comment on a publication
   * Update a message
   */
  async commentUpdateMessage(
    requestParameters: CommentUpdateMessageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CommentRead> {
    const response = await this.commentUpdateMessageRaw(requestParameters, initOverrides);
    return await response.value();
  }
}

/**
 * @export
 */
export const CommentListOrderByEnum = {
  CreatedAt: "created_at",
  CreatedAt2: "-created_at",
  UpdatedAt: "updated_at",
  UpdatedAt2: "-updated_at",
} as const;
export type CommentListOrderByEnum =
  (typeof CommentListOrderByEnum)[keyof typeof CommentListOrderByEnum];
